<template>
        <div data-name="request-campaigns" class="d-flex align-items-center">
            <Thumbnail :data="data" size="small" />
            <p class="mb-0">
                {{ data.title | truncate(truncateLength || 15)}} 
            </p>
        </div>
</template>

<script>
import { mapState } from 'vuex'
import {truncate} from '../../../../../core/filters'
import Thumbnail from '../../../../../components/Theme/Thumbnail'

export default {
    name: 'RequestCampaings',
    props: {
        data: Object,
        truncateLength: Number
    },
    filters: {
        truncate
    },
    components: {
        Thumbnail
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/variables.scss';

div[data-name="request-campaigns"] {
    img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 8px;
        object-fit: cover;
    }
    p {
        color: $c6;
        font-size: $p4;
    }
}
</style>